import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import HeaderPublic from 'components/Header/HeaderPublic';

import { LayoutProps } from '../types';

const AuthLayout = ({ children, titleKey }: LayoutProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet title={t(titleKey)} />
            <HeaderPublic />
            {children}
        </>
    );
};

export default AuthLayout;
